export function validRequire(field) {
    if (field.type == "radio") {
        return !!document.querySelector(
            'input[name="' + field.name + '"]:checked'
        );
    }

    if (field.type == "checkbox") {
        return field.checked;
    }

    return field.value === "" ? false : true;
}
